const baseUrl = "https://goodifly-va5lvx6xwa-uc.a.run.app/api"
//const baseUrl = "http://localhost:8000/api";
export default baseUrl
